
import React from 'react';
import ErrorIcon from '@mui/icons-material//Error';
import { Alert } from '@mui/material';
import LogoutButton from '../LogoutBtn';
import { contactAdminClasses, ContactAdminRoot } from './ContactAdminOrInquireLicensing.styles';


const ContactAdminOrInquireLicensing = () => (
  <ContactAdminRoot>
    <Alert
      icon={<ErrorIcon fontSize="medium" style={{ alignSelf: 'center' }} />}
      severity="error"
      variant="outlined"
      className={contactAdminClasses.alertStyle}>
      You do not have access to any Scalar valuation products. Please contact your account manager at Scalar, or if you
      would like to inquire about licensing, please visit:{' '}
      <a href="https://scalar.io/product" target="_blank" rel="noopener noreferrer">
        scalar.io/product
      </a>
    </Alert>
    <LogoutButton />
  </ContactAdminRoot>
);

export default React.memo(ContactAdminOrInquireLicensing);
